
import React from "react";
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ErrorStateProps {
  title?: string;
  description?: string;
}

export const ChatErrorState: React.FC<ErrorStateProps> = ({
  title = "Conversa não encontrada",
  description = "Não foi possível encontrar esta conversa"
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center">
      <MessageSquare className="text-luxury-red h-12 w-12 mb-4" />
      <h2 className="text-white text-xl mb-2">{title}</h2>
      <p className="text-white/70 mb-6">{description}</p>
      <Button
        onClick={() => navigate('/main/chats')}
        className="bg-luxury-red hover:bg-luxury-red/90"
      >
        Voltar para conversas
      </Button>
    </div>
  );
};
